import { render, staticRenderFns } from "./Forbidden.vue?vue&type=template&id=237b8c7a&scoped=true"
import script from "./Forbidden.vue?vue&type=script&lang=js"
export * from "./Forbidden.vue?vue&type=script&lang=js"
import style0 from "./Forbidden.vue?vue&type=style&index=0&id=237b8c7a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237b8c7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('237b8c7a')) {
      api.createRecord('237b8c7a', component.options)
    } else {
      api.reload('237b8c7a', component.options)
    }
    module.hot.accept("./Forbidden.vue?vue&type=template&id=237b8c7a&scoped=true", function () {
      api.rerender('237b8c7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/error/Forbidden.vue"
export default component.exports